// import Vue from 'vue'
import Vuet from 'vuet'
import api from './api'
import app from './app'
import config from './config'
import directive from './directive.js'
import panel from '@/components/common/panel/index'

const moment = require('moment');

import {
  Toast,
  Dialog
} from 'vant'

function addZero(val) {
  if (val < 10) {
    return '0' + val
  } else {
    return val
  }
};


function bMapToQQMap(lng, lat) {
  if (lng == null || lng == '' || lat == null || lat == '')
    return [lng, lat];

  var x_pi = 3.14159265358979324;
  var x = parseFloat(lng) - 0.0065;
  var y = parseFloat(lat) - 0.006;
  var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
  var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
  var lng = (z * Math.cos(theta)).toFixed(7);
  var lat = (z * Math.sin(theta)).toFixed(7);

  return {
    lng: parseFloat(lng),
    lat: parseFloat(lat)
  };
}



// myrule，befrecreated执行数据查询，当fetch方法返回不等于false的值时，
// 标记此组件已经加载数据（在组件对应vuet实例中增加loaded=true），后续不会在调用fetch方法
// 但是如果路由参数发生变化会重新加载
Vuet.rule('router', {
  rule({
    path
  }) {
    return {
      beforeCreate() {

        var m = this.$vuet.getModule(path) // 组件对应vuet实例
        var fetchlist = this.$vuet.getModule('root').fetchlist
        var params = this.$route.params
        var loaded = fetchlist.indexOf(path) >= 0
        if (params) {
          for (var key in params) {
            var p = params[key]
            if (params.hasOwnProperty(key)) {
              if (p == undefined) {
                p = ''
              }
              if (m[key] != p) {
                loaded = false
              }
            }
          }
        }
        if (loaded) {
          return
        }
        m.reset()
        for (var key in params) {
          if (params.hasOwnProperty(key)) {
            m[key] = params[key] || ''
          } else {
            m[key] = ''
          }
        }
        if (m.fetch) {
          var obj = m.fetch()
          if (obj && obj.then) {
            obj.then((r) => {
              if (r != false && fetchlist.indexOf(path) < 0) {
                fetchlist.push(path)
              }
            })
          } else {
            if (obj != false && fetchlist.indexOf(path) < 0) {
              fetchlist.push(path)
            }
          }
        }
      }
    }
  }
})
Vuet.rule('myneed', {
  rule({
    path
  }) {
    return {
      beforeCreate() {
        var m = this.$vuet.getModule(path) // 组件对应vuet实例
        var fetchlist = this.$vuet.getModule('root').fetchlist
        var params = this.$route.params
        var loaded = fetchlist.indexOf(path) >= 0

        m.reset()
        for (var key in params) {
          if (params[key]) {
            m[key] = params[key]
          }
        }
        if (m.fetch) {
          var obj = m.fetch()
          if (obj && obj.then) {
            obj.then((r) => {
              if (r != false && fetchlist.indexOf(path) < 0) {
                fetchlist.push(path)
              }
            })
          } else {
            if (obj != false && fetchlist.indexOf(path) < 0) {
              fetchlist.push(path)
            }
          }
        }
      }
    }
  }
})
Vuet.rule('myonce', {
  rule({
    path
  }) {
    return {
      beforeCreate() {
        var m = this.$vuet.getModule(path) // 组件对应vuet实例
        var fetchlist = this.$vuet.getModule('root').fetchlist
        var params = this.$route.params
        var loaded = fetchlist.indexOf(path) >= 0
        if (loaded) {
          return
        }

        m.reset()
        for (var key in params) {
          if (params[key]) {
            m[key] = params[key]
          }
        }
        if (m.fetch) {
          var obj = m.fetch()
          if (obj && obj.then) {
            obj.then((r) => {
              if (r != false && fetchlist.indexOf(path) < 0) {
                fetchlist.push(path)
              }
            })
          } else {
            if (obj != false && fetchlist.indexOf(path) < 0) {
              fetchlist.push(path)
            }
          }
        }
      }
    }
  }
})

var wxlogin = async function (to) {
  return new Promise((resolve, reject) => {
    let appid = config.wx.appid;
    let url = config.host + to.path;
    let params = [];
    for (var key in to.query) { //剔除掉code
      if (key != "code" && key != "state" && to.query[key])
        params.push(`${key}=${to.query[key]}`);
    }
    if (params.length > 0) {
      url += "?" + params.join("&");
    }
    let scope = 'snsapi_userinfo' // snsapi_base 静默授权，snsapi_userinfo 弹出授权页面， snsapi_login 网页应用目前仅填写
    window.location.href = 'http://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + encodeURIComponent(url) + '&response_type=code&scope=' + scope + '&state=1#wechat_redirect'
  })
}


export default {
  install(Vue) {

    var toastfunc = (msg) => {
      Toast({
        message: msg
      })
    }

    var dialogfunc = (msg) => {
      return Dialog.alert({
        message: msg
      })
    }

    var confirmfunc = (msg, suretext) => {
      return new Promise((resolve, reject) => {
        return Dialog.confirm({
          message: msg,
          confirmButtonText: suretext || "确定"
        }).then(() => {
          resolve()
        }).catch((e) => {
          return e
        })
      })
    }

    var u = navigator.userAgent

    Vue.prototype.$api = api
    Vue.prototype.$config = config
    Vue.prototype.$app = app
    Vue.prototype.$toast = toastfunc
    Vue.prototype.$alert = dialogfunc
    Vue.prototype.$confirm = confirmfunc
    Vue.prototype.$isandroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
    Vue.prototype.$isios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    Vue.prototype.$isWX = u.indexOf('micromessenger') != -1
    Vue.prototype.$b_qq_point = bMapToQQMap;
    Vue.prototype.$eventBus = new Vue();
    Vue.prototype.$time_number = (v) => {
      if (!v) {
        return '';
      }
      var r = 0;
      var vs = v.split(':');
      if (vs.length >= 1) {
        r = parseInt(vs[0]) * 60;
      }

      if (vs.length >= 2) {
        r += parseInt(vs[1]);
      }

      return r;
    }

    Vue.prototype.$number_time = (v) => {
      var m = v % 60;
      var h = (v - m) / 60;
      return `${h}:${m}`;
    }

    Vue.mixin({
      methods: {
        async $login(path) {
          if (config.wx.isWX && config.userinfo.login_status < 1) {
            wxlogin(this.$route);
          } else {
            var r = await config.showlogin();
            if (r) {
              var res = await this.$api.user.getLoginData();
              if (res.R && res.data) {
                config.setUserInfo(res.data);
                config.userinfo.login_status = 2;
              }
            }
          }
        },
        $back() {
          if (this.$config.starturl == this.$route.fullPath) {
            this.$config.starturl = '1111111'
            this.$router.push('/')
          } else {
            this.$router.go(-1)
          }
          // if (history.state && history.state.key) {
          //   this.$router.go(-1);
          // } else {
          //   this.$router.push("/");
          // }
          // if (this.$config.starturl == this.$route.fullPath) {
          //   this.$app.back();
          // } else {

          // }
        },
        $clearPath(paths) {
          if (!Array.isArray(paths)) {
            paths = [paths]
          }

          var list = this.$vuet.getModule('root').fetchlist
          paths.forEach((item, i) => {
            var index = list.indexOf(item)
            if (index >= 0) {
              list.splice(index, 1)
            }
          })
        }
      }
    })

    Vuet.options.module.$api = api
    Vuet.options.module.$app = app
    Vuet.options.module.$config = config
    Vuet.options.module.$toast = toastfunc
    Vuet.options.module.$alert = dialogfunc
    Vuet.options.module.$confirm = confirmfunc;
    Vuet.options.module.$b_qq_point = bMapToQQMap;
    Vuet.prototype.$isWX = u.indexOf('micromessenger') != -1

    Vue.use(directive);


    Vue.filter('time', (value, format, defaultvalue) => {
      if (!value) {
        return defaultvalue || ''
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(value).format(format)
    })

    Vue.filter('timeauto', (value, format, defaultvalue) => {
      return moment(value).fromNow();
    })

    Vue.filter('numberTohour', (v) => {
      var m = v % 60;
      if (m == 0) {
        var h = v / 60;
        return `${h < 10 ? "0" + h : h}:00`;
      } else {
        var h = (v - m) / 60;
        return `${h < 10 ? "0" + h : h}:${m < 10 ? "0" + m : m}`;
      }
    })

    Vue.component("panel", panel);
  }
}
